import { ActionCreator } from 'redux';
import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { TSnackbarId } from '../../store/types';
import { deleteSnackbar } from '../deleteSnackbar/deleteSnackbar';
import { suspendSnackbarsStack } from '../suspendSnackbarsStack/suspendSnackbarsStack';
import { customAction as customActionType, ECustomActionType } from '../types';

export const getDefaultActionEvent: ActionCreator<ThunkAction> = (
    snackbarId: TSnackbarId,
    customAction: customActionType = null,
    actionType?: ECustomActionType
) => {
    const action = (dispatch: Dispatch) => {
        dispatch(suspendSnackbarsStack())
        .then(() => dispatch(deleteSnackbar(snackbarId)));
        if (customAction) {
            customAction(actionType);
        }
    };
    return action;
};
